// extracted by mini-css-extract-plugin
export default {"container":"styles_container__EqKFp","detail":"styles_detail__WaGqS","setting":"styles_setting__WTRFk"};